import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=75e7f904&scoped=true&"
import script from "./Channel.vue?vue&type=script&lang=js&"
export * from "./Channel.vue?vue&type=script&lang=js&"
import style0 from "./Channel.vue?vue&type=style&index=0&id=75e7f904&lang=scss&scoped=true&"
import style1 from "./Channel.vue?vue&type=style&index=1&id=75e7f904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e7f904",
  null
  
)

/* custom blocks */
import block0 from "./Channel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports